import React from 'react'
const { individual_categories } = require('hotline_complaint_choices')
import { ReviewItems } from '../ReviewItems'
import {
  formatAddress,
  formatDateString,
  formatPersonName,
  formatReviewString,
  replacePhraseWithString
} from '../../utilities'
import {
  aliasLabel,
  cellPhoneLabel,
  dobLabel,
  employerLabel,
  employerPhoneLabel,
  homeAddressLabel,
  homePhoneLabel,
  individualCategoryLabel,
  jobTitleLabel,
  personalEmailLabel,
  physicalDescLabel,
  workEmailLabel,
  workPhoneLabel
} from '../../strings/labels'
import { subjectType } from '../../strings/types'

export const ReviewSubjectIndividual = ({
  address,
  address2,
  city,
  state,
  zip,
  country,
  first_name,
  middle_name,
  last_name,
  suffix,
  category,
  alias,
  dob,
  email,
  employment,
  phone,
  phone2,
  description,
  relationship,
  relationship_other,
  subject_type,
  editFieldName,
  onClick
}) => {
  const general_choices = require('../../choices/json/relationshipToSubject.json')
  const family_choices = require('../../choices/json/familyRelationship.json')
  const relationship_choices = { ...general_choices, ...family_choices }
  let personal_details = []
  if (
    subject_type === subjectType.business ||
    subject_type === subjectType.individual
  )
    personal_details.push({
      heading: 'Type of subject',
      value: formatReviewString(subject_type)
    })

  personal_details.push(
    {
      heading: 'Full name',
      value: formatReviewString(
        `${formatPersonName(first_name, middle_name, last_name, suffix)}`
      )
    },
    {
      heading: individualCategoryLabel,
      value: formatReviewString(individual_categories[category])
    },
    {
      heading: aliasLabel,
      value: formatReviewString(alias)
    },
    {
      heading: dobLabel,
      value: formatDateString(dob)
    },
    {
      heading: physicalDescLabel,
      value: formatReviewString(description)
    }
  )

  if (relationship)
    personal_details.push({
      heading: 'Relationship to subject',
      value: formatReviewString(
        replacePhraseWithString(
          [relationship_choices[relationship]],
          relationship_other
        ).join(', ')
      )
    })

  let contact_details = [
    {
      heading: homePhoneLabel,
      value: formatReviewString(phone2)
    },
    {
      heading: cellPhoneLabel,
      value: formatReviewString(phone)
    },
    {
      heading: workPhoneLabel,
      value: formatReviewString(employment.phone2)
    },
    {
      heading: personalEmailLabel,
      value: formatReviewString(email)
    },
    {
      heading: workEmailLabel,
      value: formatReviewString(employment.email)
    },
    {
      heading: homeAddressLabel,
      value: formatReviewString(
        formatAddress({
          line1Value: address,
          line2Value: address2,
          cityValue: city,
          stateValue: state,
          zipValue: zip,
          countryValue: country
        })
      )
    }
  ]

  let employer_details = [
    {
      heading: jobTitleLabel,
      value: formatReviewString(employment.job_title)
    },
    {
      heading: employerLabel,
      value: formatReviewString(employment.employer)
    },
    {
      heading: 'Employer address',
      value: formatReviewString(
        formatAddress({
          line1Value: employment.address,
          line2Value: employment.address2,
          cityValue: employment.city,
          stateValue: employment.state,
          zipValue: employment.zip,
          countryValue: employment.country
        })
      )
    },
    {
      heading: employerPhoneLabel,
      value: formatReviewString(employment.phone)
    }
  ]

  const addCommonProps = items =>
    items.map(item => {
      return {
        ...item,
        field_name: editFieldName,
        onClick
      }
    })

  personal_details = addCommonProps(personal_details)
  contact_details = addCommonProps(contact_details)
  employer_details = addCommonProps(employer_details)

  return (
    <React.Fragment>
      <ReviewItems items={personal_details} />
      <h3>Contact details</h3>
      <ReviewItems items={contact_details} />
      <h3>Employer information</h3>
      <ReviewItems items={employer_details} />
    </React.Fragment>
  )
}
